import React from "react";

type Props = {
  name: string;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
  round?: string;
  style?: string;
};

const Button = ({ onClick, round, name, type, style }: Props) => {
  return (
    <button
      type={type ? type : "button"}
      className={`inline-block ${
        round ? round : "rounded-lg"
      } bg-gradient p-[1px] focus:outline-none focus:ring active:text-opacity-75`}
      onClick={onClick}
    >
      <span
        className={`block ${
          round ? round : "rounded-lg"
        }  text-[12px] md:text-sm lg:text-[16px] bg-black text-white px-4 py-1 lg:px-8 lg:py-3 font-bold hover:bg-white duration-300 hover:text-black transition active:translate-y-1 ${
          style ? style : ""
        }`}
      >
        {name}
      </span>
    </button>
  );
};

export default Button;
